<div class="col-md-12 table-responsive tm-data-table">
  <table class="table table-striped " *ngIf="masters[field.masterPropName]">
    <thead>
      <tr>
        <th>
          Title
        </th>
        <th class="text-center">
          Agreed status
        </th>
        <th *ngIf="verificationRequired" class="text-right">
          Verification Status
        </th>
      </tr>

    </thead>
    <tbody>
      <!-- <ng-container *ngFor="let item of items"="expression"></ng-container> -->

      <ng-container *ngIf="masters[field.masterPropName].length;else nodata">
        <ng-container *ngFor="let item of masters[field.masterPropName];let index= index">
          <ng-container
            *ngTemplateOutlet="tr; context: {row: item, form_group:form_group, section:section, masters:masters,index:index}">
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-template #nodata>
        <div class="font-small"> No records found!</div>
      </ng-template>

    </tbody>
  </table>
</div>


<ng-template #tr let-display_row="row" let-masters="masters" let-index="index">
  <tr>
    <td (click)="view(index)" class="link">
      {{display_row.title}}
    </td>
    <td class="text-center">
      <ng-container *ngIf="display_row.agreedStatus">
        <i class="fa checkbox-icons fa-check-circle"></i>
      </ng-container>

      <ng-container *ngIf="!display_row.agreedStatus">
        <i class="fa checkbox-icons fa-times-circle"></i>
      </ng-container>

      <!-- {{}} -->
    </td>
    <td *ngIf="!masters[field.masterPropName][index].skipVerification && verificationRequired" class="text-center">
      <ng-template
        *ngTemplateOutlet="verification_status; context: {field:masters[field.masterPropName][index],section:section,verification_status_list:verification_status_list}">
      </ng-template>
    </td>
  </tr>
</ng-template>


<ng-template #verification_status let-field="field" let-form_control="form_control" let-section="section"
  let-verificationObj="verificationObj" let-form_group="form_group" let-is_section="is_section"
  let-verification_status_list="verification_status_list">
  <ng-container *ngIf="verification_status_list && verification_status_list.length && verificationRequired">
    <tm-verification-status [verificationObj]="verificationObj" [form_control]="form_control" [field]="field"
      [section]="section" [form_group]="form_group" [is_section]="is_section" [type]="2"
      [verification_status_list]="verification_status_list" [callbackFn]="callbackFn" [alertId]="alertId"
      [control_class]="'justify-content-center'">
    </tm-verification-status>
  </ng-container>
</ng-template>